
/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { negate } from '../function/negate';
import { isArray } from './isArray';
import { isBoolean } from './isBoolean';
import { isDevEnv } from './isDev';
import { isEmail } from './isEmail';
import { isEmptyArray } from './isEmptyArray';
import { isEmptyObject } from './isEmptyObject';
import { isExisty } from './isExisty';
import { isFalse } from './isFalse';
import { isFalsy } from './isFalsy';
import { isFunction } from './isFunction';
import { useHRWizVisible } from './isHRWizHeaderVisible';
import { useInMicrosoftTeams } from './isInMicrosoftTeams';
import { isJson } from './isJson';
import { isNull } from './isNull';
import { isNumber } from './isNumber';
import { isObject } from './isObject';
import { isObjectLike } from './isObjectLike';
import { isPlainObject } from './isPlainObject';
import { isString } from './isString';
import { isTrue } from './isTrue';
import { isTruthy } from './isTruthy';
import { isUndefined } from './isUndefined';
import { isDelete } from './isDelete';
import { isBackspace } from './isBackspace';
import { isPaste } from './isPaste';
import { isValidRegex } from './isValidRegex';
import { isVariable } from './isVariable';

const is = {
  array: isArray,
  boolean: isBoolean,
  dev: isDevEnv,
  email: isEmail,
  emptyArray: isEmptyArray,
  emptyObject: isEmptyObject,
  existy: isExisty,
  false: isFalse,
  falsy: isFalsy,
  function: isFunction,
  hrwizHeaderVisible: useHRWizVisible,
  inMicrosoftTeams: useInMicrosoftTeams,
  json: isJson,
  null: isNull,
  number: isNumber,
  object: isObject,
  objectLike: isObjectLike,
  plainObject: isPlainObject,
  string: isString,
  true: isTrue,
  truthy: isTruthy,
  undefined: isUndefined,
  deleteEvent: isDelete,
  backspaceEvent: isBackspace,
  pasteEvent: isPaste,
  validRegex: isValidRegex,
  variable: isVariable
};

const notInterface = {};

Object.keys(is).forEach(key => notInterface[key] = negate(is[key]));

is.not = notInterface;

export default is;
